import React from 'react';

import Chart from 'components/Chart';
import { useModal } from 'components/Modal';
import { useScreenDispatch, useScreenState } from 'components/Screen';
import { SelectPicker } from 'components/Select';
import { useMetrics } from 'scenes/DashboardPage/data/useMetrics';
import { useChart } from 'scenes/PerformancePage/data';
import { SET_METRICS } from 'scenes/PerformancePage/screenReducer';

const PerformanceChart = () => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const { data: metricsData } = useMetrics();

  const {
    data: chartData,
    isRefetching,
    isLoading,
    isError,
    error,
    isSuccess,
  }: any = useChart({
    metrics: screenState.metrics,
    filters: screenState.filters,
    dimension: screenState.dimension,
  });

  const [openMetricsModal] = useModal(SelectPicker, {
    value: screenState.metrics,
    data: metricsData,
  });
  const handleOpenMetricsModal = () => {
    openMetricsModal({
      multiple: true,
      title: 'Metrics',
      onSubmit: (value: []) => {
        dispatch({
          type: SET_METRICS,
          payload: value,
        });
      },
    });
  };

  return (
    <Chart
      showMetricsModal={handleOpenMetricsModal}
      isRefetching={isRefetching}
      isLoading={isLoading}
      isError={isError}
      isSuccess={isSuccess}
      error={error}
      data={chartData}
    />
  );
};

export default PerformanceChart;
